import xhr from "lib/xhr";

export const requestPassword = async (params) => {
  return await xhr.post(`/users/password`, params);
};

export const updatePassword = async (params) => {
  return await xhr.post(`/users/password/update`, params);
};
